import { render, staticRenderFns } from "./cart-item.vue?vue&type=template&id=5565baec"
import script from "./cart-item.vue?vue&type=script&lang=ts"
export * from "./cart-item.vue?vue&type=script&lang=ts"
import style0 from "./cart-item.vue?vue&type=style&index=0&id=5565baec&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5565baec')) {
      api.createRecord('5565baec', component.options)
    } else {
      api.reload('5565baec', component.options)
    }
    module.hot.accept("./cart-item.vue?vue&type=template&id=5565baec", function () {
      api.rerender('5565baec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/cart/cart-item.vue"
export default component.exports